import React from 'react'
import gql from 'graphql-tag'
import { Mutation } from 'react-apollo'
import { PureQueryOptions } from 'apollo-client'

export const updateApplicationLibraryStatusMutation = gql`
  mutation UpdateApplicationLibraryStatus(
    $organizationID: ID!
    $applicationID: ID!
    $hashes: [String!]!
    $status: ApplicationLibraryStatusType!
  ) {
    updateApplicationLibraryStatus(
      input: {
        organizationID: $organizationID
        applicationID: $applicationID
        hashes: $hashes
        status: $status
      }
    ) {
      _placeholder
    }
  }
`

export interface UpdateApplicationLibraryStatusMutationArgs {
  readonly organizationID: string
  readonly applicationID: string
  readonly hashes: string[]
  readonly status: string
}

export function UpdateApplicationLibraryStatusMutation({
  children
}: {
  readonly children: (
    updateApplicationLibraryStatus: (
      variables: UpdateApplicationLibraryStatusMutationArgs,
      refetchQueries: PureQueryOptions[]
    ) => Promise<any>
  ) => React.ReactNode
}) {
  return (
    <Mutation<{}, UpdateApplicationLibraryStatusMutationArgs>
      mutation={updateApplicationLibraryStatusMutation}
    >
      {(updateApplicationLibraryStatus) => {
        return children(
          async (
            variables: UpdateApplicationLibraryStatusMutationArgs,
            refetchQueries
          ) =>
            updateApplicationLibraryStatus({
              variables,
              refetchQueries
            })
        )
      }}
    </Mutation>
  )
}
